import { cn } from '@/lib/utils.js';
import { useI18n } from '../../i18n/index.js';

// A compact brand lockup for page/board headers that sit OUTSIDE the sidebar
// (TV boards, kiosks, report screens). The blue EDAL wordmark is illegible on
// navy, so on dark headers it sits on a white chip — same rule as Logo/KioskHeader.
export function BrandMark({ tone = 'dark', className }: { tone?: 'dark' | 'light'; className?: string }): JSX.Element {
  return (
    <span className={cn('inline-flex items-center gap-2 flex-shrink-0', className)}>
      <span className={cn('inline-flex items-center justify-center rounded-lg p-1', tone === 'dark' ? 'bg-white' : '')}>
        <img src="/edal-logo-transparent.png" alt="EDAL Robotics & Automation" className="w-9 h-9 object-contain" />
      </span>
    </span>
  );
}

// Brand header that appears ONLY on paper. Every printed screen (QR labels, NC
// report, station sheets) then carries the company mark, title and date without
// taking room on screen.
export function PrintBrand({ title }: { title: string }): JSX.Element {
  // הכותרת המודפסת הייתה עברית קשיחה, וגם התאריך היה נעול ל-`he-IL` — דף
  // שיוצא מתחת ידיו של טכנאי דובר רוסית נקרא על ידו, ולא רק מתויק.
  const { t, dir, locale } = useI18n();
  return (
    <div className="hidden print:flex items-center gap-3 border-b border-navy-300 pb-2 mb-3" dir={dir}>
      <img src="/edal-logo-transparent.png" alt="EDAL" className="w-12 h-12 object-contain" />
      <div className="flex-1">
        <div className="font-bold text-black leading-tight">{t('brand.company')}</div>
        <div className="text-sm text-black">{title}</div>
      </div>
      <div className="text-xs text-black">{new Date().toLocaleString(locale)}</div>
    </div>
  );
}
